module.exports = __webpack_public_path__ + "img/data1-3.ef242914.png";